import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const NavigateToNodeButton = ({ node }) => (
  <Link to={`/nodes/${node.id}`} className="ui labeled icon button">
    <i className="right arrow icon" /> Naviguer
  </Link>
);

NavigateToNodeButton.propTypes = {
  node: PropTypes.object.isRequired,
};

export default NavigateToNodeButton;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NavigateToNodeButton.js